/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const RECEIVE_NOTE_ALL_TAGS = (id: string) => [
  {type: 'receiveNoteState' as const, id},
  {type: 'receiveNoteInfo' as const, id},
];

export const RECEIVE_NOTE_FAST_TRACK_ALL_TAGS = (id: string) => [
  {type: 'receiveNoteFastTrackItems' as const, id},
  {type: 'receiveNoteFastTrackIssues' as const, id},
];

export const RECEIVE_NOTE_BASKET_ALL_TAGS = (id: string) => [
  {type: 'receiveNoteBasketItems' as const, id},
  {type: 'receiveNoteBasketTotalPrice' as const, id},
];
